import React from 'react';
import ComicButton from '../components/ui/ComicButton';
import SpeechBubble from '../components/ui/SpeechBubble';
import { FiDownload, FiEye, FiBookOpen, FiStar } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Program = () => {
  const pdfUrl = "https://www.hastingscomedyfestival.com/_files/ugd/9fff18_e198e2df566a4fb4843666c97cbeab70.pdf";

  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
      {/* Header */}
      <div className="text-center mb-16 relative">
        <div className="inline-block bg-hcf-purple border-4 border-black p-6 shadow-comic transform -rotate-1">
          <h1 className="font-comic text-6xl md:text-8xl text-hcf-yellow drop-shadow-[4px_4px_0_#EC008C]">FESTIVAL GUIDE</h1>
        </div>
        <div className="absolute -top-10 right-10 hidden md:block animate-bounce">
          <SafeIcon icon={FiStar} className="text-7xl text-hcf-yellow" />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
        {/* Visual Preview - Reduced from col-span-5 to col-span-4 (~20% reduction in grid space) */}
        <div className="md:col-span-4">
          <div className="relative group">
            <div className="absolute inset-0 bg-hcf-pink translate-x-4 translate-y-4 border-4 border-black rounded-lg"></div>
            <div className="relative border-4 border-black bg-white p-2 shadow-comic overflow-hidden rotate-[-2deg] transition-transform group-hover:rotate-0">
               <img 
                 src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1770308908583-image.png" 
                 alt="Program Mockup" 
                 className="w-full h-auto border-2 border-black group-hover:scale-105 transition-all duration-500"
               />
               <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-black/40">
                  <div className="bg-hcf-yellow text-black font-comic text-3xl px-6 py-2 border-4 border-black rotate-12">
                    2026 EDITION
                  </div>
               </div>
            </div>
          </div>
        </div>

        {/* Content & Actions - Increased to col-span-8 to fill space */}
        <div className="md:col-span-8 space-y-8">
          <SpeechBubble direction="left" className="border-hcf-cyan mt-8">
            <span className="text-hcf-pink font-bold text-2xl uppercase">Everything you need to know!</span>
            <br/>
            Venues, Maps, Showtimes, and exclusive interviews with Chris & Jake.
          </SpeechBubble>

          <div className="bg-white border-4 border-black p-8 shadow-comic relative overflow-hidden">
            <div className="absolute top-0 right-0 p-4 opacity-10">
              <SafeIcon icon={FiBookOpen} className="text-9xl" />
            </div>
            <h2 className="font-comic text-4xl mb-6 text-black">GET YOUR DIGITAL COPY</h2>
            <p className="font-body text-xl mb-8 leading-relaxed">
              Our 2026 Digital Program is packed with 40+ pages of comedy gold. 
              Plan your week, find your favorite acts, and discover hidden gem venues across Hastings & St Leonards.
            </p>

            <div className="flex flex-wrap gap-4">
              <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
                <ComicButton variant="primary" className="bg-hcf-cyan text-white hover:bg-white hover:text-hcf-cyan border-black flex items-center gap-2">
                  <SafeIcon icon={FiEye} /> VIEW ONLINE
                </ComicButton>
              </a>
              <a href={pdfUrl} download>
                <ComicButton variant="danger" className="bg-hcf-pink text-white hover:bg-white hover:text-hcf-pink border-black flex items-center gap-2">
                  <SafeIcon icon={FiDownload} /> DOWNLOAD PDF
                </ComicButton>
              </a>
            </div>
          </div>

          <div className="bg-hcf-yellow border-4 border-black p-4 inline-block transform rotate-1">
             <p className="font-comic text-xl">PRO TIP: SAVE THIS TO YOUR PHONE FOR EASY ACCESS AT THE VENUES!</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Program;